import { queryOptions } from "@tanstack/react-query";

import { fetchVoucherTemplates } from "./requests";

const VoucherTemplatesQueries = {
  all: () =>
    queryOptions({
      queryKey: ["voucherTemplates"],
      queryFn: () => fetchVoucherTemplates(),
      select: (data) => data.sort((a, b) => a.value - b.value),
    }),
};

export default VoucherTemplatesQueries;
